import { render, staticRenderFns } from "./LoginMessage.vue?vue&type=template&id=4f70e01a"
import script from "./LoginMessage.vue?vue&type=script&lang=js"
export * from "./LoginMessage.vue?vue&type=script&lang=js"
import style0 from "./LoginMessage.vue?vue&type=style&index=0&id=4f70e01a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports